export enum WizardModelNames {
  WIZARD = 'WIZARD',
}
